module.exports = __webpack_public_path__ + "static/2-4906d8bd20e4599be5e79d20e51d53c7.png";